const API = process.env.REACT_APP_API || 'http://localhost:2567';
const WS = process.env.REACT_APP_WS || 'ws://localhost:2567';

export { API, WS };
